import { render, staticRenderFns } from "./StatusText.vue?vue&type=template&id=04c42fc8&scoped=true"
import script from "./StatusText.vue?vue&type=script&lang=js"
export * from "./StatusText.vue?vue&type=script&lang=js"
import style0 from "./StatusText.vue?vue&type=style&index=0&id=04c42fc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c42fc8",
  null
  
)

export default component.exports